<template>
  <div>
    <div :class="(loading ? 'show-loader' : 'hide-loader')">
      <div class="el-loading-spinner">
        <svg viewBox="25 25 50 50" class="circular">
          <circle cx="50" cy="50" r="20" fill="none" class="path"></circle>
        </svg><!---->
      </div>
    </div>
    <div class="row order-view">
      <div class=" col-lg-12 col-md-12 pad-to-15">
        <div class="row">
          <div class="col-md-12 posunset">
            <div class="card hightfixed posunset">
              <div class="card-content">
                <div class="row ">
                  <div class="col-sm-12">
                    <h6 class="noprint"><i class="ti-panel"></i> {{$t('orders.updateStatus')}}</h6>

                    <hr class="noprint" style="clear:both;">
                  </div>
                </div>
                <div class="row pad-bt-15 sticky-order-view-header">
                  <div class="col-md-12">
                    <div class="pull-left status-line pad-to-10 order-buttons resize-method">
                      <template v-for="(sts, i) in orderStatuses">
                        <button class="btn" :disabled="!sts.isAllowed || order.is_refunded === 1 || btStatusBlocked(sts.type)" :class="((currentOrdersStatus === sts.type ) ? sts.type : '') + ' ' +'mr-1-rem current btn-' + orderStatusClass(sts.type)" @click.prevent="changeStatusFromButtons(sts.type)" v-model="currentOrdersStatus">
                          {{changeDeliveryStatusForLabel(sts.type)}}
                          <!-- v-bind:style="{ backgound: orderStatusButtonColor(sts.type), textColor:'white' }" -->
                        </button>
                      </template>
                    </div>
                    <div class="pull-right" style="display:inline-flex">
                      <select class="form-control" @change.prevent="changeStatus" v-model="currentOrdersStatus">
                        <option v-for="(sts, i) in orderStatuses"
                                :disabled="!sts.isAllowed || order.is_refunded === 1 || btStatusBlocked(sts.type)"
                                :value="sts.type">
                                {{changeDeliveryStatusForLabel(sts.type)}}
                              <!-- {{$t('ordersStatus.' + changeDeliveryStatusForLabel(sts.type)}} -->
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-12">
            <div class="card">
              <div class="card-content">
                
                <div class="row pad-to-15">
                  <div class="col-sm-12">
                    <h6 class="pull-left print-lg-font">{{$t('orders.single')}} <span style="text-transform:none;">#{{order.token}}</span></h6>
                    <h6 class="pull-right"><i class="ti-shopping-cart"></i> {{$t('orders.ordDetails')}}</h6>
                    <hr style="clear:both;">
                  </div>
                </div>
                <div class="row display-flex resized-min-width-1600" v-if="order.status">
                  <div class="col-md-6 col-print-6">
                    <div class="row pad-bt-10" v-if="showLocations">
                      <div class="col-lg-5 col-sm-6 col-md-6 col-xs-12 details-label">{{$t('orders.ordLocation')}}</div>
                      <div class="col-lg-7 col-sm-5 col-md-6 col-xs-12"><b>{{order.production_details ? order.production_details.location.name : '-'}}</b></div>
                    </div>

                    <div class="row pad-bt-10">
                      <div class="col-lg-5 col-sm-6 col-md-6 col-xs-12 details-label col-print-6">{{$t('orders.date')}}</div>
                      <div class="col-lg-7 col-sm-5 col-md-6 col-xs-12 col-print-6"><b>{{formatDate(order.created_at)}}</b></div>
                    </div>
                    <div class="row pad-bt-10" v-if="order.delivery_type == 'MEET_HALF'">
                      <div class="col-lg-5 col-sm-6 col-md-6 col-xs-12 details-label col-print-6">{{$t('orders.meetupLocation')}}</div>
                      <div class="col-lg-7 col-sm-5 col-md-6 col-xs-12 col-print-6"><b>{{order.delivery_details ? order.delivery_details.location.name : ''}}</b></div>
                    </div>
                    <div class="row pad-bt-10">
                      <div class="col-lg-5 col-sm-6 col-md-6 col-xs-12 details-label col-print-6">{{$t('orders.madeAt')}}</div>
                      <div class="col-lg-7 col-sm-5 col-md-6 col-xs-12 col-print-6"><b>{{formatTime(order.created_at)}}</b></div>
                    </div>
                    <div class="row pad-bt-10" v-if="order.delivery_type !== 'EAT_LOCATION'">
                      <div class="col-lg-5 col-sm-6 col-md-6 col-xs-12 details-label pad-to-10 col-print-6 text-color-red"><b style="font-size:larger">{{$t('orders.pickupTime')}}</b></div>
                      <div class="col-lg-7 col-sm-5 col-md-6 col-xs-12 col-print-6">
                        <el-time-picker
                          disabled="true"
                          v-model="order.formatted_pickup_datetime"
                          class="in-inline-120"
                          arrow-control
                          :value-format="timeFormat" :format="timeFormat"
                          placeholder="Select time">
                        </el-time-picker>
                        <!-- <button class="btn btn-success btn-icon noprint" disabled @click.prevent="updateHour" :title="$t('general.save')"><i class="ti-save"></i></button> -->
                      </div>
                    </div>
                    <div class="row pad-bt-10" v-else>
                      <div class="col-lg-5 col-sm-6 col-md-6 col-xs-12 details-label col-print-6 text-color-red"><b style="font-size:larger">{{$t('orders.reservationTime')}}</b></div>
                      <div class="col-lg-7 col-sm-5 col-md-6 col-xs-12 col-print-6 ">
                        <b>{{formatDate(order.pickup_datetime)}} {{formatTime(order.pickup_datetime)}}</b>
                      </div>
                    </div>
                    <template  v-if="order.delivery_type !== 'EAT_LOCATION'">
                      <div class="row pad-bt-10" >
                        <div class="col-lg-5 col-sm-6 col-md-6 col-xs-12 details-label pad-to-10 col-print-6"></div>
                        <div class="col-lg-7 col-sm-5 col-md-6 col-xs-12 col-print-6 order-delivery-time-buttons justify-space-evenly pad-lf-0">
                          <template v-for="min in orderTimeDelivery()">
                            <button :disabled="order.status.id === 'DELIVERED'" class="btn btn-info btn-icon noprint mr-1-rem hour-button" @click="automatUpdateHour(min, 'add')" :title="$t('general.save')">+{{min}}m</button>
                          </template>
                        </div>
                      </div>
                      <div class="row pad-bt-10" >
                        <div class="col-lg-5 col-sm-6 col-md-6 col-xs-12 details-label pad-to-10 col-print-6"></div>
                        <div class="col-lg-7 col-sm-5 col-md-6 col-xs-12 col-print-6 order-delivery-time-buttons justify-space-evenly pad-lf-0">
                          <!-- this is not used because dinamic width needed foreach button -->
                          <!-- <template v-for="min in orderTimeDelivery()">
                            <button class="btn btn-danger btn-icon noprint mr-1-rem hour-button" @click="automatUpdateHour(min, 'sub')" :title="$t('general.save')">-{{min}}m</button>
                          </template> -->
                          <button class="btn btn-danger btn-icon noprint mr-1-rem hour-button" :disabled="order.status.id === 'DELIVERED'"  style="width: 47px;" @click="automatUpdateHour(5, 'sub')" :title="$t('general.save')">-5m</button>
                          <button class="btn btn-danger btn-icon noprint mr-1-rem hour-button" :disabled="order.status.id === 'DELIVERED'"  style="width: 51px;" @click="automatUpdateHour(15, 'sub')" :title="$t('general.save')">-15m</button>
                          <button class="btn btn-danger btn-icon noprint mr-1-rem hour-button" :disabled="order.status.id === 'DELIVERED'"  style="width: 54px;" @click="automatUpdateHour(30, 'sub')" :title="$t('general.save')">-30m</button>
                          <button class="btn btn-danger btn-icon noprint mr-1-rem hour-button" :disabled="order.status.id === 'DELIVERED'"  style="width: 54px;" @click="automatUpdateHour(45, 'sub')" :title="$t('general.save')">-45m</button>
                          <button class="btn btn-danger btn-icon noprint mr-1-rem hour-button" :disabled="order.status.id === 'DELIVERED'"  style="width: 55px;" @click="automatUpdateHour(55, 'sub')" :title="$t('general.save')">-60m</button>
                        </div>
                      </div>
                    </template>
                    <template v-if="order.user_labeling">
                      <div class="row pad-bt-10" >
                        <div class="col-lg-5 col-sm-6 col-md-6 col-xs-12 details-label col-print-6">{{$t('orders.note')}}</div>
                        <div class="col-lg-7 col-sm-5 col-md-6 col-xs-12 col-print-6">
                          <template v-if="order.user_labeling">
                            <b class="text-danger">{{convetLabelingJson(order.user_labeling)}}</b>
                          </template>
                        </div>
                      </div>
                    </template>

                  </div>
                  <div class="col-md-6 col-print-6" _style="padding-right: 0px !important;">
                    <div class="height-70-percent">
                      <div class="row pad-bt-10">
                        <div class="col-lg-5 col-sm-6 col-xs-12 col-print-6 details-label">{{$t('orders.payment')}}</div>
                        <div class="col-lg-7 col-sm-5 col-xs-12 col-print-6">
                          <b>{{$t('paymentTypes.' + order.payment_type)}}</b>
                          <b v-if="order.payment_type === 'CARD' && order.is_refunded === 0" v-html="getPaymetnStatus(order.capture_transaction_status)"></b>
                          <div v-if="order.payment_id === 'btIpay'" class="help-block noprint">
                            <strong>BT iPay</strong> — {{$t('btPayments.captureHelp')}}
                            <button class="btn btn-sm" @click.prevent="getData">{{$t('btPayments.refresh')}}</button>
                          </div>
                          <b v-if="order.payment_type === 'CARD' && order.is_refunded === 1">
                            - <span class="text-danger">{{$t('orders.amountRefunded')}}</span>        
                            <br>
                            <span class="text-muted"><small>{{$t('orders.amountIntegralRefunded')}}</small></span>
                          </b>
                        </div>
                      </div>
                      <div class="row pad-bt-10">
                        <div class="col-lg-5 col-sm-6 col-xs-12 col-print-6 details-label">{{$t('general.deliveryMethod')}}</div>
                        <div class="col-lg-7 col-sm-5 col-xs-12 col-print-6"><b>
                          <template v-if="order.company_id === 31 && order.delivery_type === 'MEET_HALF'">Due Drive</template>
                          <template v-if="order.company_id === 46 && order.delivery_type === 'MEET_HALF'">Yumm Drive</template>
                          <template v-else>{{$t('deliveryTypes.' + order.delivery_type)}}</template>
                        </b></div>
                      </div>
                      <div class="row pad-bt-10" v-if="order.delivery_type === 'EAT_LOCATION'">
                        <div class="col-lg-5 col-sm-6 col-xs-12 col-print-6 details-label">{{$t('orders.reservationSeats')}}</div>
                        <div class="col-lg-7 col-sm-5 col-xs-12 col-print-6"><b>{{order.delivery_details ? order.delivery_details.how_many : '-'}}</b></div>
                      </div>
                      <!-- <template v-if="order.comments">  -->
                        <div class="row pad-bt-10">
                          <div class="col-lg-5 col-sm-6 col-xs-12 col-print-6 details-label"><template v-if="order.comments">{{$t('orders.custComments')}}</template></div>
                          <div class="col-lg-7 col-sm-5 col-xs-12 col-print-6 " :class="order.comments ? 'text-danger' : ''"> <template v-if="order.comments"><span v-html="order.comments || '<small>'+$t('orders.none')+'</small>'"></span></template></div>
                        </div>
                      <!-- </template> -->
                    </div>
                    <div class="row pad-bt-10 height-30-percent display-flex align-items-flex-end">
                      <div class="col-lg-12 col-sm-12 col-xs-12 col-print-12 details-label" style="padding-right: 0px !important;">
                        <div class="col-lg-1 col-sm-1 col-xs-12 col-print-6 details-label"></div>
                        <div class="col-lg-11 col-sm-11 col-xs-12 col-print-6 justify-content-flex-end display-inline-flex">
                          <!-- <div class="ml-10-rem"> -->
                            <template v-if="order.delivery_type === 'DELIVERY' && order.packageez_flag">
                              <button class="btn btn-info mar-rt-10" :id="'call-courier-' + order.id" v-if="!cancelOrder && (order.status.id === 'NEW' || order.status.id === 'PROCESSING' || order.status.id === 'PREPARED')" @click.prevent="courierCall(order.id, order.store_id)">{{$t("orders.callCourier")}}</button>
                              <button class="btn btn-danger mar-rt-10" :id="'cancel-order-' + order.id" v-if="cancelOrder && (order.status.id === 'NEW' || order.status.id === 'PROCESSING' || order.status.id === 'PREPARED')"  @click.prevent="cancelCourierOrder(order.id, order.store_id)">{{$t("general.cancelCourier")}}</button>
                              <button class="btn btn-danger mar-rt-10" :id="'cancel-order-disabled-' + order.id" v-if="order.status.id === 'TRANSPORT' || order.status.id === 'CANCELED' || order.status.id === 'NOT_DELIVERED'" disabled="disabled" @click.prevent="cancelCourierOrder(order.id, order.store_id)">{{$t("general.cancel")}}</button>
                            </template>

                            <button class="btn btn-warning mar-rt-10 noprint"
                                    v-if="canShowRefundButton"
                                    :disabled="refundLoading || refundAlreadyDone || btReturnPending"
                                    @click.prevent="doRefundOrder">
                              <i class="fa fa-undo print-icon"></i>
                              <template v-if="refundAlreadyDone">{{$t('orders.refundAlreadyDone')}}</template>
                              <template v-else-if="btReturnPending">{{$t('btPayments.returnPending')}}</template>
                    <template v-else>{{$t('orders.refundOrder')}}</template>
                            </button>
                  <div v-if="btReturnPending" class="text-warning noprint" role="status">
                    {{$t('btPayments.returnHelp')}}
                    <button class="btn btn-sm" @click.prevent="getData">{{$t('btPayments.refresh')}}</button>
                  </div>
                            <button class="btn btn-info mar-rt-10 noprint" @click.prevent="printPage"><i class="fa fa-print print-icon"></i> {{$t('orders.print')}}</button>
                            <button style="" 
                                    class="btn btn-info noprint" 
                                    v-if="showPrintBtn"
                                    @click.prevent="sendToPrinter">
                                    <i class="fa fa-print print-icon"></i> {{$t('orders.printerPrint')}}
                            </button>
                          <!-- </div> -->
                        </div>
                        
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div> <!--  end col-md-12  -->

          <div class="col-md-12 col-print-12" style="display: flex; justify-content: space-between; margin-bottom: 20px; padding: 0;">
            <div :class="(order.address.shipping ? 'col-md-6 col-print-6' : 'col-md-12 col-print-12')">
              <div class="card" style="margin: auto; height: 100%;">
                <div class="card-content">
                  <div class="row">
                    <div class="col-xs-12">
                      <h6 class="mar-to-0"> <img class="icon-card-header" src="/static/img/icons/user-sm.png">  {{$t('orders.custDetails')}}</h6>
                      <hr class="sm">
                    </div>
                  </div>
                  <div class="row pad-bt-10">
                    <div class="col-lg-2 col-sm-3 col-xs-12 details-label"><b>{{$t('customers.name')}}</b></div>
                    <div class="col-lg-10 col-sm-8 col-xs-12" v-if="order.delivery_details_firstname"><b>{{order.delivery_details_firstname }} </b></div>
                    <div class="col-lg-10 col-sm-8 col-xs-12" v-else=""><b>{{order.customer ? order.customer.firstname : ''}} {{order.customer ? order.customer.lastname : ''}}</b></div>
                  </div>
                  <div class="row pad-bt-10">
                    <div class="col-lg-2 col-sm-3 col-xs-12 details-label"><b>{{$t('customers.email')}}</b></div>
                    <div class="col-lg-10 col-sm-8 col-xs-12">{{order.customer ? order.customer.email : ''}}</div>
                  </div>
                  <div class="row pad-bt-10">
                    <div class="col-lg-2 col-sm-3 col-xs-12 details-label"><b>{{$t('customers.phone')}}</b></div>
                    <div v-if="order.delivery_details_phone" class="col-lg-10 col-sm-8 col-xs-12">{{order.delivery_details_phone}}</div>
                    <div v-else class="col-lg-10 col-sm-8 col-xs-12">{{(order.customer && order.customer.phone) ? order.customer.phone : '-'}}</div>
                  </div>
                </div>
              </div>
            </div>

            <template v-if="order.address.shipping">
              <div class="col-md-6 col-print-6" >
                <div class="card address-box" style="margin: auto; height: 100%;">
                  <div class="card-content">
                    <h6>{{$t('orders.shipping')}}</h6>
                    <hr class="sm">
                    <div class="address-content">
                        <b>{{order.address.shipping.address_name ? order.address.shipping.address_name : '' }}</b><br/>{{order.address.shipping.street ? order.address.shipping.street : ''}} {{order.address.shipping.number ? order.address.shipping.number : ''}}, {{order.address.shipping.apartment ? order.address.shipping.apartment : ''}}<br/>
                        {{order.address.shipping.city ? order.address.shipping.city : ''}},
                        {{order.address.shipping.state ? order.address.shipping.state : ''}}<br/>
                        <span v-show="order.address.shipping.country">{{order.address.shipping.country ? order.address.shipping.country : ''}}<br/></span>
                        {{order.address.shipping.other_info ? order.address.shipping.other_info : ''}}
                      
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </div>

          <div class="col-md-12">
            <div class="card">
              <div class="">

                <table class="table orders-table">
                  <thead>
                      <tr>
                        <th>{{$t('orders.name')}}</th>
                        <th>{{$t('orders.qty')}}</th>
                        <th>{{$t('orders.unit')}}</th>
                        <th>{{$t('orders.total')}}</th>
                      </tr>
                  </thead>
                  <tbody>
                    <template v-for="customer in order.parts">
                      <tr v-if="order.order_type=='GROUP'" class="active"><td colspan="4">{{$t('customers.single')}}: {{customer.customer_name}}</td></tr>
                      <tr v-for="prod in customer.items">
                        <td>
                          {{prod.name}}
                          <!-- <ul v-if="prod.options">
                            <li v-for="opt in prod.options"> -->
                              <div v-for="opt in prod.options">+ {{opt.name}}<span v-if="opt.price>0"> ({{ formatMoneyAmount(opt.price, currency) }})</span></div>
                          <!--   </li>
                          </ul> -->
                          <div v-if="prod.additional_info != ''" class="pad-to-10"><span >{{$t('orders.custComments')}}: <i class="text-danger">{{prod.additional_info}}</i></span></div>
                        </td>
                        <td>{{prod.quantity}}</td>
                        <td>{{formatMoneyAmount(prod.price, currency)}}</td>
                        <td><b>{{formatMoneyAmount(parseFloat(prod.quantity) * parseFloat(prod.price_total_product), currency)}}</b></td>
                      </tr>
                    </template>
                  </tbody>
                </table>
                <div class="clearfix"> </div>
                <div class="col-md-5 order-comment">
                  <!-- <h6><img class="pad-rg-5" src="/static/img/icons/comment.png">  {{$t('orders.custComments')}}</h6>
                  <hr class="sm">
                  {{order.comments ? order.comments : $t('orders.none')}} -->
                </div>
                <div class="col-md-7">
                  <table class="table no-border totals-table">
                    <tbody>
                      <template v-for="label of totals">
                        <tr :class="getRowClass(label)" v-if="label == 'totals_grandtotal' || order[label] > 0">
                          <td>
                            <span v-if="label != 'totals_extras'">{{$t('orders.' + label)}}</span>
                            <span v-else-if="$t('orders.' + label + '_' + order.company_id) != 'orders.' + label + '_' + order.company_id">
                              {{$t('orders.' + label + '_' + order.company_id)}}
                            </span>     
                            <span v-else="">{{$t('orders.' + label)}}</span>                      
                            <span v-show="label == 'totals_discount'">(Coupon: {{coupon}})</span>
                          </td>
                          <td class="text-right">{{formatMoneyAmount(order[label], currency, true)}}</td>
                        </tr>
                      </template>
                    </tbody>
                  </table>
                </div>
                <div class="clearfix"> </div>
              </div>
            </div>
          </div>
          <div class="clearfix"> </div>
          <div class="col-md-12">
            <div class="card">
              <div class="card-content">
                <h6><img class="pad-rg-5" src="/static/img/icons/comment.png">  {{$t('orders.adminComments')}}</h6>
                <!-- <hr class="sm"> -->
                <div class="form-group">
                  <textarea class="form-control" :placeholder="$t('orders.none')" rows="5" v-model="order.backoffice_comments"></textarea>
                </div>
                <div class="form-group">
                  <button class="btn btn-icon btn-success noprint" @click.prevent="saveComment" :title="$t('general.save')"><i class="ti-save"></i></button>
                </div>
              </div>
            </div>

          </div> <!-- end col-md-6  -->

        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import Vue from 'vue'
  import BtOrderPayment from 'src/mixins/BtOrderPayment'
  import {Select, Option, TimePicker, DatePicker, TimeSelect} from 'element-ui'
  import DataTables from 'vue-data-tables'
  import moment from 'moment'
  import countriesList from './../Customers/countries'
  import swal from 'sweetalert2'
  import 'sweetalert2/dist/sweetalert2.css'
  Vue.use(Select)
  Vue.use(DataTables)
  Vue.use(TimePicker)
  Vue.use(DatePicker)
  Vue.use(TimeSelect)
  export default {
    mixins: [BtOrderPayment],
    components: {
      [Select.name]: Select,
      [Option.name]: Option,
      [TimePicker.name]: TimePicker,
      [DatePicker.name]: DatePicker,
      [TimeSelect.name]: TimeSelect
    },
    props: {
      showLocations: {
        type: Boolean,
        required: true
      },
      callback: {
        required: true
      }
    },
    data () {
      return {
        order: [],
        coupon: '',
        countries: countriesList,
        modelValidations: {
          required: {
            required: true
          }
        },
        orderStatuses: [],
        currentOrdersStatus: 'NEW',
        usesExtraCosts: false,
        currecy: '',
        timeFormat: this.getTimeFormat(),
        loading: true,
        refundLoading: false,
        showPrintBtn: false,
        totals: [
          'totals_subtotals',
          'totals_shipping',
          'totals_extras',
          'totals_tip',
          'totals_discount',
          'totals_discount_loyalty_points',
          'totals_grandtotal'
        ],
        cancelOrder: null
      }
    },
    created: function () {
      this.getData()
    },
    computed: {
      // Keep the existing EuPlatesc rule; BT returns require a verified transaction.
      canShowRefundButton () {
        const order = this.order
        if (!order || !order.status) {
          return false
        }
        return (
          order.payment_type === 'CARD' &&
          !!order.transaction_id &&
          (order.payment_id === 'btIpay' || (order.payment_id === 'euplatesc' && !!order.pay_link))
        )
      },
      // Already refunded / reversed -> keep the button visible but disabled
      // and relabeled, so it is obvious the refund was already handled.
      refundAlreadyDone () {
        const order = this.order
        if (!order) {
          return false
        }
        const status = order.capture_transaction_status
        return (
          order.is_refunded === 1 ||
          order.is_refunded === true ||
          status === 'reversal OK' ||
          status === 'refund OK'
        )
      }
    },
    methods: {
      getRowClass (label) {
        switch (label) {
          case 'totals_discount_loyalty_points':
          case 'totals_discount':
            return 'text-danger'
          case 'totals_grandtotal': return 'text-bold total-row'
          default: return ''
        }
      },
      isNew () {
        if (this.$route.params.id) {
          return false
        } else {
          return true
        }
      },
      disabledCls (isBefore) {
        if (isBefore) {
          return 'disabled'
        } else {
          return ''
        }
      },
      getPaymetnStatus (status) {
        if (this.order.payment_id === 'btIpay' && status === 'AUTHORIZED') {
          return ' - <span class="text-info">' + this.$t('btPayments.authorized') + '</span>'
        }
        switch (status) {
          // case null:
          //   return this.$t('paymentStatus.notPaid')
          case 'OK':
            return ' - <span class="text-success">' + this.$t('paymentStatus.paid') + '</span>'
          case 'NOT OK':
            return ' - <span class="text-danger">' + this.$t('paymentStatus.notOk') + '</span>'
          default:
            return ' - <span class="text-warning">' + this.$t('paymentStatus.notPaid') + '</small></span> <br><span class="text-muted"><small>' + this.$t('paymentStatus.notPaidDetails') + '</small></span>'
        }
      },
      // Pull the most meaningful text out of an apiRequest response. On a non-2xx
      // reply the mixin resolves to { status: false, error: <axiosError> }, so the
      // API's JSON body (with its `message`) lives under error.response.data.
      refundErrorMessage (response) {
        if (response) {
          if (response.error && response.error.response && response.error.response.data) {
            const data = response.error.response.data
            if (data.message) {
              return data.message
            }
            if (data.error) {
              return data.error
            }
          }
          if (response.message) {
            return response.message
          }
        }
        return this.$t('orders.refundError')
      },
      doRefundOrder () {
        var self = this
        if (this.refundAlreadyDone || this.refundLoading || this.btReturnPending) {
          return
        }
        swal({
          title: self.$t('orders.refundConfirmTitle'),
          text: self.$t(self.order.payment_id === 'btIpay' ? 'btPayments.refundConfirm' : 'orders.refundConfirmText'),
          type: 'warning',
          showCancelButton: true,
          cancelButtonText: self.$t('general.cancel'),
          confirmButtonText: self.$t('orders.refundOrder')
        }).then((result) => {
          if (!result) {
            return
          }
          var id = self.$route.params.id
          var data = {
            token: self.$session.get('token'),
            company_id: self.$session.get('selectedCompany'),
            order_id: parseInt(id)
          }
          self.refundLoading = true
          self.$nextTick(function () {
            self.loading = true
          })
          self.apiRequest('/refound-order', 'POST', data, function (response) {
            self.refundLoading = false
            self.$nextTick(function () {
              self.loading = false
            })
            if (response && response.success === true) {
              if (self.order.payment_id === 'btIpay' && response.pending === true) {
                self.handleBtReturnQueued()
                return
              }
              swal({
                title: '',
                text: response.message || self.$t('orders.refundSuccess'),
                type: 'success'
              }).then(() => {
                self.afterRefundSuccess(id)
              }).catch(() => {
                self.afterRefundSuccess(id)
              })
            } else {
              swal({
                title: '',
                text: self.refundErrorMessage(response),
                type: 'error'
              })
            }
          })
        }).catch(() => {})
      },
      afterRefundSuccess (id) {
        var self = this
        // Refresh the order (updates is_refunded / status buttons) and the list.
        self.$session.set('refreshOrdersCount', 'refresh')
        self.getData()
        if (typeof self.callback === 'function') {
          self.callback(id)
        }
        // If the order is not cancelled yet, offer to cancel it now. On confirm we
        // cancel WITHOUT the legacy automat-refund step (money was already returned).
        if (!self.order || !self.order.status || self.order.status.id === 'CANCELED') {
          return
        }
        swal({
          title: '',
          text: self.$t('orders.refundAskCancel'),
          type: 'question',
          showCancelButton: true,
          cancelButtonText: self.$t('general.cancel')
        }).then((result) => {
          if (result) {
            self.cancelAfterRefund(id)
          }
        }).catch(() => {})
      },
      cancelAfterRefund (id) {
        var self = this
        var data = {
          id: id,
          token: self.$session.get('token'),
          company_id: self.$session.get('selectedCompany'),
          status: 'CANCELED'
        }
        self.apiRequest('/order/' + id, 'PUT', data, function (response) {
          if (response.status === true) {
            self.$session.set('refreshOrdersCount', 'refresh')
            self.$bus.$emit('stopSound')
            swal({
              text: self.$t('orders.orderStatusSuccess'),
              type: 'success',
              showConfirmButton: false,
              timer: 1500
            })
            self.getData()
            if (typeof self.callback === 'function') {
              self.callback(id, {'id': 'CANCELED', 'type': self.$t('ordersStatus.CANCELED')})
            }
          } else if (response.errors && response.errors.boogit) {
            swal({
              text: response.errors.boogit,
              type: 'error',
              showConfirmButton: false,
              timer: 1500
            })
          } else {
            swal('', self.$t('validations.wentWrong'), 'error')
          }
        })
      },
      showPrint () {
        let companyLocations = this.$session.get('selectedCompanyData')
        let locationId = this.order.production_details.location.id
        let show = false
        for (let location of companyLocations.locations_details) {
          if (location.id === locationId && location.use_printer !== undefined && location.use_printer) {
            show = true
          }
        }
        return show
      },
      getData () {
        this.$nextTick(function () {
          this.loading = true
        })
        var data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany')
        }
        var self = this
        // get product data
        if (self.$route.params.id) {
          var id = self.$route.params.id

          self.apiRequest('/order/' + id, 'GET', data, function (response) {
            if (response.status === true) {
              response.data[0].formatted_pickup_datetime = self.formatTime(response.data[0].pickup_datetime)
              self.order = response.data[0]
              self.coupon = self.order.coupon
              if (self.order.applyCoupons) {
                self.coupon = ''
                for (let cupons in self.order.applyCoupons) {
                  self.coupon += self.order.applyCoupons[cupons].coupon_code
                  self.coupon += ', '
                }
                self.coupon = self.coupon.slice(0, -2)
              }
              for (var iParts in self.order.parts) {
                for (var iItem in self.order.parts[iParts].items) {
                  let item = self.order.parts[iParts].items[iItem]
                  let sumOptions = 0
                  if (item.options && item.options.length) {
                    sumOptions = item.options.map(item => item.price).reduce((prev, next) => parseFloat(prev) + parseFloat(next))
                  }
                  self.order.parts[iParts].items[iItem].price_total_product = (parseFloat(item.price) + parseFloat(sumOptions)).toFixed(2)
                }
              }
              let statusesRaw = self.$session.get('defaultData')['order_statuses']
              var isBefore = true
              var isAllowed = true
              self.cancelOrder = !!self.order.packagez_order_id
              self.orderStatuses = []
              self.currentOrdersStatus = self.order.status.id
              for (var ordType in statusesRaw) {
                // console.warn(ordType)
                for (var type in statusesRaw[ordType]) {
                  if (ordType === self.order.delivery_type && type !== 'DRAFT') {
                    if (type === 'CANCELED' && self.order.payment_type === 'CARD' && self.order.capture_transaction_status === 'OK') {
                      isAllowed = false
                    } else if (self.order.delivery_type === 'EAT_LOCATION') {
                      isAllowed = true
                    } else {
                      isAllowed = self.orderStatusAllowed(self.order.status.id, type)
                    }
                    self.orderStatuses.push({
                      'type': type,
                      'text': statusesRaw[ordType][type],
                      'isBefore': isBefore,
                      'isAllowed': isAllowed
                    })
                    if (self.order.status.id === type) {
                      isBefore = false
                    }
                  }
                }
              }

              self.currency = response.data[0]['currency']

              self.showPrintBtn = self.showPrint()

              self.$nextTick(function () {
                self.loading = false
              })
            }
          })
        }
      },
      heartbeat (orderData) {
        // console.warn(' ------ heart beat on single order ---------')
        var self = this
        self.order.status = orderData.status

        let statusesRaw = self.$session.get('defaultData')['order_statuses']
        var isBefore = true
        var isAllowed = true

        self.orderStatuses = []
        self.currentOrdersStatus = self.order.status.id

        for (var ordType in statusesRaw) {
          for (var type in statusesRaw[ordType]) {
            if (ordType === self.order.delivery_type && type !== 'DRAFT') {
              isAllowed = self.orderStatusAllowed(self.order.status.id, type)
              self.orderStatuses.push({
                'type': type,
                'text': statusesRaw[ordType][type],
                'isBefore': isBefore,
                'isAllowed': isAllowed
              })
              if (self.order.status.id === type) {
                isBefore = false
              }
            }
          }
        }
        this.$nextTick(() => {
          // trigger next tick
        })
      },
      updateHour () {
        var id = this.$route.params.id
        var self = this
        if (this.order.formatted_pickup_datetime === '' || this.order.formatted_pickup_datetime === null) {
          swal({'text': self.$t('orders.orderHourError'), 'type': 'error', 'showConfirmButton': false, 'timer': 2000}).catch({})
        } else {
          var newTime = moment(String(this.order.pickup_datetime)).format('YYYY-MM-DD')
          newTime = moment(String(newTime + ' ' + this.order.formatted_pickup_datetime)).format('YYYY-MM-DD HH:mm:ss')
          var data = {
            id: id,
            token: this.$session.get('token'),
            company_id: this.$session.get('selectedCompany'),
            pickup_datetime: newTime
          }
          // console.warn(data)
          this.apiRequest('/order/' + id, 'PUT', data, function (response) {
            // console.warn(response)
            if (response.status === true) {
              swal(
                '',
                self.$t('orders.orderHourSuccess'),
                'success'
              )
            } else {
              swal(
                '',
                this.$t('validations.wentWrong'),
                'error'
              )
            }
          })
        }
      },
      automatUpdateHour (time, flag) {
        var id = this.$route.params.id
        var self = this
        if (this.order.formatted_pickup_datetime === '' || this.order.formatted_pickup_datetime === null) {
          swal({'text': self.$t('orders.orderHourError'), 'type': 'error', 'showConfirmButton': false, 'timer': 2000}).catch({})
        } else {
          var newTime = moment(String(this.order.pickup_datetime)).format('YYYY-MM-DD')
          if (flag === 'add') {
            newTime = moment(String(newTime + ' ' + this.order.formatted_pickup_datetime)).add(time, 'minutes').format('YYYY-MM-DD HH:mm:ss')
          } else {
            newTime = moment(String(newTime + ' ' + this.order.formatted_pickup_datetime)).subtract(time, 'minutes').format('YYYY-MM-DD HH:mm:ss')
          }
          var data = {
            id: id,
            token: this.$session.get('token'),
            company_id: this.$session.get('selectedCompany'),
            pickup_datetime: newTime
          }
          if (moment(this.order.created_at).format('YYYY-MM-DD HH:mm:ss') > moment(newTime).format('YYYY-MM-DD HH:mm:ss')) {
            swal(
              '',
              this.$t('validations.hourIsSmallerThanCreated'),
              'error'
            )
          } else {
            this.apiRequest('/order/' + id, 'PUT', data, function (response) {
              if (response.status === true) {
                self.order.formatted_pickup_datetime = self.formatTime(response.data[0].pickup_datetime)
                swal(
                  '',
                  self.$t('orders.orderHourSuccess'),
                  'success'
                )
                self.callback(id, null, response.data[0].pickup_datetime)
              } else {
                swal(
                  '',
                  this.$t('validations.wentWrong'),
                  'error'
                )
              }
            })
          }
        }
      },
      saveComment () {
        var id = this.$route.params.id
        var data = {
          id: id,
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany'),
          backoffice_comments: this.order.backoffice_comments
        }
        var self = this
        this.apiRequest('/order/' + id, 'PUT', data, function (response) {
          // console.warn(response)
          if (response.status === true) {
            swal(
              '',
              self.$t('orders.orderCommnetSuccess'),
              'success'
            )
          } else {
            swal(
              '',
              this.$t('validations.wentWrong'),
              'error'
            )
          }
        })
      },
      updateStatus (status, label, disabled, revertOnCancel = false) {
        if (disabled) {
          return false
        }
        var self = this
        swal({
          text: self.$t('validations.areYouSure') + this.changeDeliveryStatus(status),
          type: 'question',
          showCancelButton: true,
          cancelButtonText: this.$t('general.cancel')
        })
        .then((result) => {
          if (result) {
            var id = this.$route.params.id
            var data = {
              id: id,
              token: this.$session.get('token'),
              company_id: this.$session.get('selectedCompany'),
              status: status
            }
            this.apiRequest('/order/' + id, 'PUT', data, function (response) {
              if (response.status === true) {
                // set value for refreshOrdersCount - used in SideBar.vue
                self.$session.set('refreshOrdersCount', 'refresh')
                let msg = self.$t('orders.orderStatusSuccess')
                if (response.data_specials !== undefined && response.data_specials.printer_error !== undefined) {
                  msg = msg + self.$t('orders.orderPrinterError')
                }
                // stop sound
                if (response.data[0].status.id !== 'NEW') {
                  self.$bus.$emit('stopSound')
                }
                if (response.data[0].status.id === 'CANCELED') {
                  for (var ordstat of self.orderStatuses) {
                    ordstat.isAllowed = false
                  }
                }
                swal({
                  text: msg,
                  type: 'success',
                  showConfirmButton: false,
                  timer: 1500
                })
                .then(() => {
                  let companyLocations = self.$session.get('selectedCompanyData')
                  let locationId = self.order.production_details.location.id
                  companyLocations.locations_details.forEach(async(location) => {
                    if (location.id === locationId && status === 'PROCESSING' && location.auto_print) {
                      setTimeout(() => {
                        self.printPage()
                      }, 3000)
                    }
                  })
                })
                if (status !== 'CANCELED') {
                  // set value for refreshOrdersCount - used in SideBar.vue
                  self.$session.set('refreshOrdersCount', 'refresh')
                  let msg = self.$t('orders.orderStatusSuccess')
                  if (response.data_specials !== undefined && response.data_specials.printer_error !== undefined) {
                    msg = msg + self.$t('orders.orderPrinterError')
                  }
                  swal({
                    text: msg,
                    type: 'success',
                    showConfirmButton: false,
                    timer: 1500
                  })
                  .then(() => {
                    let companyLocations = self.$session.get('selectedCompanyData')
                    let locationId = self.order.production_details.location.id
                    companyLocations.locations_details.forEach(async(location) => {
                      if (location.id === locationId && status === 'PROCESSING' && location.auto_print) {
                        setTimeout(() => {
                          self.printPage()
                        }, 3000)
                      }
                    })
                  })
                  self.getData()
                  self.callback(id, {'id': status, 'type': label})
                } else if (status === 'CANCELED' && response.data[0].payment_id === 'btIpay') {
                  if (self.order.transaction_id && !self.refundAlreadyDone) self.handleBtReturnQueued()
                  else self.getData()
                } else if (status === 'CANCELED' && response.data[0].payment_type === 'CARD') {
                  if (response.data[0].was_delivery_before) {
                    swal({
                      text: self.$t('orders.refundManual'),
                      type: 'success',
                      showConfirmButton: false,
                      timer: 1500
                    })
                    self.getData()
                    self.callback(id, {'id': status, 'type': label})
                  } else {
                    setTimeout(() => {
                      let que = self.$t('orders.refundAutomat')
                      swal({
                        text: que,
                        type: 'question',
                        showCancelButton: true,
                        cancelButtonText: self.$t('general.cancel')
                      })
                      .then((res) => {
                        const data2 = {
                          id: id,
                          token: self.$session.get('token'),
                          company_id: self.$session.get('selectedCompany'),
                          status: status
                        }
                        self.apiRequest('/automat-refund', 'POST', data2, function (response) {
                          if (response.status === true) {
                            swal({
                              text: self.$t('orders.' + response.data),
                              type: 'success',
                              showConfirmButton: false,
                              timer: 1500
                            })
                          } else {
                            swal({
                              text: self.$t('orders.' + response.errors.error),
                              type: 'error',
                              showConfirmButton: false,
                              timer: 1500
                            })
                          }
                          self.getData()
                          self.callback(id, {'id': status, 'type': label})
                        })
                      })
                    }, 2000)
                  }
                }
              } else if (response.errors.boogit) {
                swal({
                  text: response.errors.boogit,
                  type: 'error',
                  showConfirmButton: false,
                  timer: 1500
                })
              } else {
                swal(
                  '',
                  self.$t('validations.wentWrong'),
                  'error'
                )
                if (revertOnCancel) {
                  self.currentOrdersStatus = self.order.status.id
                }
              }
            })
          }
        }).catch(() => {
          if (revertOnCancel) {
            self.currentOrdersStatus = self.order.status.id
          }
        })
      },
      changeStatus () {
        var status = this.currentOrdersStatus
        var label = this.$t('ordersStatus.' + this.currentOrdersStatus)
        this.updateStatus(status, label, false, true)
      },
      changeStatusFromButtons (type) {
        this.currentOrdersStatus = type
        var status = this.currentOrdersStatus
        var label = this.$t('ordersStatus.' + this.currentOrdersStatus)
        this.updateStatus(status, label, false, true)
      },
      printPage () {
        window.print()
      },
      sendToPrinter () {
        this.$nextTick(function () {
          this.loading = true
        })
        var id = this.$route.params.id
        var data = {
          token: this.$session.get('token')
        }
        var self = this
        this.apiRequest('/print/' + id, 'GET', data, function (response) {
          self.$nextTick(function () {
            self.loading = false
          })
          if (response.status === true) {
            swal(
              '',
              self.$t('orders.printerSuccess'),
              'success'
            )
          } else {
            swal(
              '',
              self.$t('orders.printerErrror'),
              'error'
            )
          }
        })
      },
      changeDeliveryStatusForLabel (status) {
        var self = this
        if (status === 'DELIVERED' && self.order.delivery_type === 'EAT_LOCATION') {
          status = 'RESERVED'
        }
        if (status === 'DELIVERED' && self.order.delivery_type === 'PICK_UP') {
          status = 'COMPLETED'
        }
        return this.$t('ordersStatus.' + status)
      },
      changeDeliveryStatus (status) {
        var self = this
        if (status === 'DELIVERED' && self.order.delivery_type === 'EAT_LOCATION') {
          status = 'RESERVED'
        }
        if (status === 'DELIVERED' && self.order.delivery_type === 'PICK_UP') {
          status = 'COMPLETED'
        }
        if (status === 'CANCELED') {
          status = this.$t('canceledForever')
        }
        return this.$t('ordersStatus.' + status)
      },
      convetLabelingJson (labeling) {
        const label = JSON.parse(labeling)
        return label.notification
      },
      courierCall (id, locationId) {
        var data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany'),
          id: id,
          location_id: locationId
        }
        swal({
          title: this.$t('orders.packageDetails'),
          html: '<div style:"display: inline-grid; justify-items: stretch; flex-direction: column;"><div style="margin-top: 14px;"><label style="margin-top: inherit;">' + this.$t('orders.packageSize') + '</label><select id="package-size-' + id + '" class="swal2-select" style="display: block; margin-top: auto;"><option value="30x30x10">30x30x10</option><option value="30x30x20">30x30x20</option><option value="30x30x30">30x30x30</option><option value="60x60x30">60x60x30</option></select></div>' + '<div><label>' + this.$t('orders.courierTime') + '</label><select id="package-time-' + id + '" class="swal2-select" style="display: block; margin-top: auto;"><option value="1">' + this.$t('orders.now') + '</option><option value="15">15 min</option><option value="30">30 min</option></select></div>',
          showCancelButton: true,
          cancelButtonText: this.$t('general.cancel')
        }).then((result) => {
          data.size = document.getElementById('package-size-' + id).value
          data.time = document.getElementById('package-time-' + id).value
          if (result) {
            this.apiRequest('/packagez-send-order', 'POST', data, (response) => {
              if (response.status === true) {
                swal({
                  text: this.$t('orders.orderSentSuccess'),
                  type: 'success',
                  timer: 1000,
                  showConfirmButton: false
                })
                this.cancelOrder = true
              } else {
                swal({
                  text: response.errors.package,
                  type: 'error',
                  timer: 2000,
                  showConfirmButton: false
                })
              }
            })
          }
        })
      },
      cancelCourierOrder (id, locationId) {
        var data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany'),
          id: id,
          location_id: locationId
        }
        swal({
          text: this.$t('orders.callCourierCancel'),
          type: 'question',
          showCancelButton: true
        }).then((result) => {
          if (result) {
            this.apiRequest('/packagez-cancel-order', 'POST', data, (response) => {
              if (response.status === true) {
                swal({
                  text: this.$t('orders.orderCancelSuccess'),
                  type: 'success',
                  timer: 1000,
                  showConfirmButton: false,
                  cancelButtonText: this.$t('general.cancel')
                })
                this.cancelOrder = false
              } else {
                swal({
                  text: response.errors.order,
                  type: 'error',
                  timer: 2000,
                  showConfirmButton: false
                })
              }
            })
          }
        })
      }
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/OrdersPos/OrdersPosView.vue